import React from 'react'
import { Link } from 'react-router-dom'
import saveAs from "file-saver";
import { newFetch, POST } from '../../../../helpers/fetch'

const DownloadTemplate = ({ template }) => {
  const downloadFile = async (e) => {
    e.preventDefault()
    const api_path = `/site/download_template`
    const response = await newFetch(POST, api_path, { file: template })
    if(response.success){
      const filename = `template.csv`
      const buffer = response.data.data
      const arraybuffer = Uint8Array.from(buffer).buffer;
      // const blob = new Blob([arraybuffer], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"})
      const blob = new Blob([arraybuffer], {type: 'text/csv;charset=utf-8;'})
      saveAs(blob, filename)
    }
  }

  return (
    <Link className="d-flex mt-auto pt-2 pb-2"  to="#" onClick={(e) => downloadFile(e)}>
      {" "}Download template here.{" "}
    </Link>
  )
}

export default DownloadTemplate